const ACCEPT_FORMAT_LABELS: Record<string, string> = {
  "application/pdf": "PDF",
  "application/msword": "DOC",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "DOCX",
  "application/vnd.ms-excel": "XLS",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
  "text/csv": "CSV",
  "text/plain": "TXT",
  "image/png": "PNG",
  "image/jpeg": "JPEG",
  "image/jpg": "JPG",
  "image/webp": "WEBP",
  "image/gif": "GIF",
  "image/svg+xml": "SVG",
};

/**
 * Turn a raw `accept` attribute (mime types and/or extensions) into a friendly,
 * de-duplicated, uppercased list for display — e.g. "application/pdf,.pdf" -> "PDF",
 * "image/png, image/jpeg" -> "PNG, JPEG". Falls back to the extension/subtype so
 * unmapped-but-simple types still read cleanly.
 */
export function humanizeAccept(accept: string): string {
  const labels: string[] = [];
  const seen = new Set<string>();

  for (const raw of accept.split(",")) {
    const token = raw.trim().toLowerCase();
    if (!token) continue;

    let label = "";
    if (token.startsWith(".")) {
      label = token.slice(1).toUpperCase();
    } else if (ACCEPT_FORMAT_LABELS[token]) {
      label = ACCEPT_FORMAT_LABELS[token];
    } else if (token.includes("/")) {
      const subtype = token.split("/")[1] ?? "";
      if (subtype && !subtype.includes(".")) label = subtype.toUpperCase();
    } else {
      label = token.toUpperCase();
    }

    if (label && !seen.has(label)) {
      seen.add(label);
      labels.push(label);
    }
  }

  return labels.join(", ");
}
